// extracted by mini-css-extract-plugin
export var active = "_dm-7";
export var container = "_dm-0";
export var evenWidth = "_dm-4";
export var large = "_dm-5";
export var outlet = "_dm-8";
export var slide = "_dm-2";
export var small = "_dm-6";
export var tab = "_dm-3";
export var tabs = "_dm-1";